// Mock data for the portfolio website
export const personalData = {
  name: "Gideon Metre",
  title: "Senior Investment Management Leader",
  subtitle: "AI Implementation Sponsor | Building High-Performance Teams & Driving Innovation",
  email: "gideonpeter1633@gmail.com",
  phone: "+91 8087613486",
  linkedin: "https://www.linkedin.com/in/gideon-metre",
  location: "Mumbai, India",
  
  // Key metrics for hero section
  metrics: {
    experience: "14+",
    teamSize: "27",
    fteSaved: "300+",
    engagementScore: "98%"
  },

  // Professional summary
  summary: `A results-driven professional with 14+ years of transformative experience in asset management, 
    AI implementation, and building high-performance teams that deliver exceptional results. Currently leading 
    19+ professionals across 8 cross-functional teams at Russell Investments.`,

  // Work experience
  experience: [
    {
      id: 1,
      company: "Russell Investments",
      position: "Associate Director",
      duration: "Mar 2024 - Present",
      description: "Leading Implementation Portfolio Management, AI initiatives, and cross-functional teams of 27 people.",
      achievements: [
        "Strategic leadership reporting to Global MD",
        "AI Implementation sponsor for Mumbai office", 
        "Established Investment Division's CPS department from ground-up",
        "Portfolio management for North America and EMEA clients"
      ],
      teams: [
        "Implementation Portfolio Management (IPM)",
        "Currency/FX Portfolio Management", 
        "Equity/EPI Portfolio Management",
        "Overlay Services Portfolio Management",
        "Investment Reporting",
        "Portfolio Analysts",
        "Transition Management (TM)",
        "Personalized Managed Accounts (PMA)",
        "Security Lending"
      ]
    },
    {
      id: 2,
      company: "TIAA GBS",
      position: "Senior Associate/Manager",
      duration: "Jan 2019 - Mar 2024",
      location: "Pune",
      description: "Investment Accounting, Business Intelligence, Process Automation and Fund Administration.",
      achievements: [
        "Led cross-functional 4 teams, built ICOE process ground-up",
        "Delivered 300+ FTE hours through automation projects",
        "98% engagement score with 0% attrition for 4 years",
        "Oversight of State Street outsourced operations"
      ]
    },
    {
      id: 3,
      company: "FIS (SunGard)",
      position: "Senior Analyst",
      duration: "Feb 2017 - Jan 2019", 
      location: "Mumbai",
      description: "Post Trade Derivatives Collateral Management and OTC clearing operations.",
      achievements: [
        "Managed OTC clearing and collateral management",
        "Acted as clearing member for CCPs (ICE, EUREX, LCH)",
        "Key automation developer with VBA coding expertise",
        "Introduced new ISA product offerings to clients"
      ]
    }
  ],

  // Technical skills
  technicalSkills: [
    "Alteryx Analytics & Automation",
    "VBA Programming", 
    "SQL & Power BI",
    "Python (Basic)",
    "Microsoft Power Automate",
    "SharePoint",
    "Bloomberg Terminal",
    "Crystal Reports"
  ],

  // Domain expertise
  domainSkills: [
    "Portfolio Management",
    "Asset Management", 
    "Investment Operations",
    "Risk Management",
    "Derivatives Trading",
    "Fund Administration",
    "Security Lending",
    "Process Automation"
  ],

  // Leadership skills
  leadershipSkills: [
    "Team Building",
    "Strategic Leadership",
    "Cross-functional Management", 
    "Process Improvement",
    "Stakeholder Management",
    "Performance Management",
    "Change Management",
    "Business Analysis"
  ],

  // Education
  education: [
    {
      degree: "MBA Finance",
      institution: "Sinhagad Management School, Pune",
      year: "2013"
    },
    {
      degree: "Bachelor of Science in Mathematics", 
      institution: "Modern College, Pune",
      year: "Prior to MBA"
    }
  ],

  // Certifications
  certifications: [
    "Alteryx Foundation Micro-credential Certified",
    "Bloomberg Terminal Certified"
  ]
};

export const projectsData = [
  {
    id: 1,
    title: "AI-Powered Portfolio Analytics Dashboard",
    category: "Data Analytics & AI",
    description: "Developed comprehensive analytics dashboard using Alteryx and Power BI for real-time portfolio performance monitoring.",
    technologies: ["Alteryx", "Power BI", "SQL", "VBA"],
    impact: "Reduced reporting time by 60% and improved decision-making speed",
    status: "Completed",
    image: "https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg"
  },
  {
    id: 2,
    title: "Automated Trade Reconciliation System",
    category: "Process Automation",
    description: "Built end-to-end automation system for trade reconciliation using VBA and SharePoint integration.",
    technologies: ["VBA", "SharePoint", "Microsoft Power Automate"],
    impact: "Eliminated 150+ manual hours per month, 90% error reduction",
    status: "Completed",
    image: "https://images.pexels.com/photos/7876495/pexels-photo-7876495.jpeg"
  },
  {
    id: 3,
    title: "AI Meeting Assistant & Office Scheduler",
    category: "AI & Productivity",
    description: "Developed Outlook Meeting AI Assistant and Office Seats Scheduler Application using Gen AI technologies.",
    technologies: ["Python", "Gen AI", "Outlook APIs", "Machine Learning"],
    impact: "Improved meeting efficiency by 40% and optimized office space utilization",
    status: "In Development",
    image: "https://images.unsplash.com/photo-1738566061977-fdd59ca5b08e"
  },
  {
    id: 4,
    title: "Investment Reporting Warehouse Optimization",
    category: "Data Engineering",
    description: "Optimized investment reporting warehouse using OAC/OBIEE for better data quality and faster processing.",
    technologies: ["OAC/OBIEE", "SQL", "Data Modeling"],
    impact: "50% improvement in report generation time, enhanced data accuracy",
    status: "Completed",
    image: "https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg"
  }
];

export const blogData = [
  {
    id: 1,
    title: "The Future of AI in Investment Management",
    excerpt: "Exploring how artificial intelligence is revolutionizing portfolio management and investment decision-making processes.",
    category: "AI & Finance",
    readTime: "8 min read",
    publishDate: "2024-02-15",
    status: "published",
    image: "https://images.unsplash.com/photo-1738566061977-fdd59ca5b08e"
  },
  {
    id: 2,
    title: "Building High-Performance Teams in Financial Services", 
    excerpt: "Lessons learned from leading cross-functional teams and achieving 98% engagement scores with zero attrition.",
    category: "Leadership",
    readTime: "6 min read", 
    publishDate: "2024-01-28",
    status: "published",
    image: "https://images.pexels.com/photos/7876495/pexels-photo-7876495.jpeg"
  },
  {
    id: 3,
    title: "Automation Success Stories: 300+ FTE Hours Saved",
    excerpt: "How strategic automation using Alteryx and VBA transformed operational efficiency across multiple teams.",
    category: "Process Automation",
    readTime: "10 min read",
    publishDate: "2024-01-10", 
    status: "published",
    image: "https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg"
  },
  {
    id: 4,
    title: "The Evolution of Portfolio Management Technology",
    excerpt: "A deep dive into how technology is reshaping portfolio management from traditional methods to AI-driven strategies.",
    category: "Technology",
    readTime: "12 min read",
    publishDate: "2024-03-01",
    status: "draft",
    image: "https://images.unsplash.com/photo-1738566061977-fdd59ca5b08e"
  }
];

export const contactData = {
  email: "gideonpeter1633@gmail.com",
  phone: "+91 8087613486", 
  linkedin: "https://www.linkedin.com/in/gideon-metre",
  location: "Mumbai, India",
  availability: "Open to new opportunities and collaborations"
};
